import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=9f118ace&scoped=true&"
import script from "./UserInvite.vue?vue&type=script&lang=js&"
export * from "./UserInvite.vue?vue&type=script&lang=js&"
import style0 from "./UserInvite.vue?vue&type=style&index=0&id=9f118ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../share_webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f118ace",
  null
  
)

export default component.exports